<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card flat>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-col cols="12" sm="3">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
            </v-col>
          </v-card-title>
          <v-data-table :headers="headers" :items="contacts"  :search="search" hide-default-footer :loading="loading">
              <template v-slot:[`item.createdAt`]="{ item }">
                {{ item.createdAt | formatdate }}
              </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'Contacts',
  data: () => ({
    search: '',
    headers: [
      { text: 'Name', value: 'name' },
      { text: 'Phone Number', value: 'phoneNumber' },
      { text: 'Date Created', value: 'createdAt' }
    ],
    loading: false,
    contacts: []
  }),
  created () {
    this.triggerGetContacts()
  },
  methods: {
    ...mapActions({ getContacts: 'contacts/getContacts' }),
    triggerGetContacts () {
      this.loading = true
      this.contacts = []
      this.getContacts().then(response => {
        this.contacts = response.data.data
        this.loading = false
      }).catch(error => {
        this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.data.message }, { root: true })
        this.loading = false
      })
    }
  }
}
</script>
